export const onGeneralAndDescFormsHandler = (
  forms,
  initialFormData,
  savedForms,
  languagesLength,
  secondLanguage,
  secondFormName,
  currentFormName,
  isVisitedPrices,
  isSaveUnsavedChanges,
  onChangeActivityTypeHandler,
  showSnackbarToFillAllField,
  confirmActivityType
) => {
  const _forms = [currentFormName];
  let savedFormsCopy = { ...savedForms };
  let isSetPriceActiveSubTab = false;

  if (languagesLength > 1) _forms.push(`${currentFormName}-${secondLanguage}`);

  for (let i in _forms) {
    if (!_forms.hasOwnProperty(i)) continue;

    const formName = _forms[i];
    const form = { ...forms[formName] };

    if (!form || !form.values || form.syncErrors) {
      showSnackbarToFillAllField();
      return false;
    }

    if (formName === 'generalForm') {
      if (savedForms[formName]) {
        if (savedForms[formName].activityType !== form.values.activityType) {
          isSetPriceActiveSubTab = true;
        }
      } else if (
        initialFormData[formName].activityType !== form.values.activityType
      ) {
        isSetPriceActiveSubTab = true;
      }
    }

    savedFormsCopy = {
      ...savedFormsCopy,
      [formName]: { ...form.values }
    };
  }

  if (isSetPriceActiveSubTab && isVisitedPrices && isSaveUnsavedChanges) {
    onChangeActivityTypeHandler(savedFormsCopy, secondFormName);
    return false;
  }

  if (isSetPriceActiveSubTab && isVisitedPrices && !isSaveUnsavedChanges) {
    confirmActivityType(savedFormsCopy, secondFormName);
    return false;
  }

  return savedFormsCopy;
};
